;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"b56c8b75c3eec0ce2be47fc92a0ea1c0ca2f2f69"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.2.0";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/video/:id\",\"regex\":\"^/video/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/video/:id/status\",\"regex\":\"^/video/([^/]+)/status$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/login\"},{\"path\":\"/login/error\"},{\"path\":\"/login/verify\"},{\"path\":\"/\"},{\"path\":\"/contact\"},{\"path\":\"/pricing\"},{\"path\":\"/privacy\"},{\"path\":\"/profile\"},{\"path\":\"/search\"},{\"path\":\"/submit\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

/**
 * Client-side Sentry init. Runs in the browser after hydration.
 * No-op when NEXT_PUBLIC_SENTRY_DSN isn't set.
 */
if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // NEXT_PUBLIC_SENTRY_RELEASE is set by the deploy workflow to the
    // git commit SHA and baked into the client bundle. Matches the
    // release name withSentryConfig used when uploading source maps,
    // giving Sentry a release+URL fallback when debug-ID matching
    // doesn't catch a frame.
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 0,
    // Don't ship session replay — adds ~70KB and we don't need it.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

// Required by Next.js navigation instrumentation.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
